"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { loggerLink, unstable_httpBatchStreamLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import { useState } from "react";
import SuperJSON from "superjson";
import { createQueryClient } from "./query-client";
let clientQueryClientSingleton = undefined;
const getQueryClient = () => {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return createQueryClient();
  }
  // Browser: use singleton pattern to keep the same query client
  return clientQueryClientSingleton ??= createQueryClient();
};
export const api = createTRPCReact();

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */

export function TRPCReactProvider(props) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getQueryClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryClient = t0;
  const [trpcClient] = useState(_temp3);
  let t1;
  if ($[1] !== props.children || $[2] !== trpcClient) {
    t1 = <QueryClientProvider client={queryClient}><api.Provider client={trpcClient} queryClient={queryClient}>{props.children}</api.Provider></QueryClientProvider>;
    $[1] = props.children;
    $[2] = trpcClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp3() {
  return api.createClient({
    links: [loggerLink({
      enabled: _temp
    }), unstable_httpBatchStreamLink({
      transformer: SuperJSON,
      url: getBaseUrl() + "/api/trpc",
      headers: _temp2
    })]
  });
}
function _temp2() {
  const headers = new Headers();
  headers.set("x-trpc-source", "nextjs-react");
  return headers;
}
function _temp(op) {
  return process.env.NODE_ENV === "development" || op.direction === "down" && op.result instanceof Error;
}
export function getBaseUrl() {
  if (typeof window !== "undefined") return window.location.origin;
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`;
  return `http://localhost:${process.env.PORT ?? 3000}`;
}